








import Vue from 'vue'
import { Datetime } from 'vue-datetime'
import moment from 'moment-timezone'
import Tenant from '@/types/Tenant.interface'
export default Vue.extend({
    components: { Datetime },
    props: {
        //  The placeholder text for the component
        content: {
            type: String,
            default: 'Select Date/Time'
        },
        //  The existing value that prepopulates the control
        insert: {
            type: String,
            default: null
        },
        //  Applies the compact style
        compact: {
            type: Boolean,
            default: false
        },
        // Min Date
        minimumDate: {
            type: String,
            required: false,
            default: null
        },
        // Max date
        maximumDate: {
            type: String,
            required: false,
            default: null
        },
        // The title that shows up on the picker
        title: {
            type: String,
            required: false,
            default: null
        },
        // Date Formate
        format: {
            type: String,
            required: false,
            default: 'MMM d, y h:mm a (ZZZZ)'
        },
        type: {
            type: String,
            default: 'datetime'
        }
    },
    data: () => ({
        datetime: null,

        setMinDate: null,

        setMaxDate: null
    }),
    created() {
        // Set the min date
        this.setMinDate = this.minimumDate
            ? this.convertToDatetime(this.minimumDate)
            : this.minDate()

        // Set the max date
        this.setMaxDate = this.maximumDate
            ? this.convertToDatetime(this.maximumDate)
            : this.maxDate()
    },
    mounted() {
        //  If compact is set, apply compact style to vdatetime element
        if (this.compact) this.applyCompact()

        //  If we have a existing value, set it
        if (this.insert) {
            const time = this.convertToDatetime(this.insert)

            this.datetime = time

            this.$emit('change')
        }
    },
    computed: {
        tenant(): Tenant {
            return this.$store.getters.tenant
        }
    },
    methods: {
        applyCompact(): void {
            //  Apply the 'compact' style to the vdatetime element
            this.$refs.picker.$el.setAttribute(
                'style',
                'height:30px; padding:2px; margin:0px;'
            )
        },
        dateTimeStyle(): string {
            let compact = this.compact ? ' compact' : ''

            //  If the user has selected a datetime, return 'selected' style
            if (this.datetime) return `datetime-selected text-left${compact}`

            //  Else, return the 'placeholder' style
            return `primary datetime-placeholder${compact}`
        },
        maxDate(): string {
            let date = new Date()
            date.setFullYear(date.getFullYear() + 1)
            return date.toISOString()
        },
        minDate(): string {
            return new Date().toISOString()
        },
        convertToDatetime(str: string): string {
            return moment.tz(str, this.tenant.default_timezone).toISOString()
        },
        submit(dateTimeString: string): void {
            this.$emit('submit', dateTimeString)
        }
    },
    watch: {
        maximumDate(): void {
            this.setMaxDate = this.maximumDate
                ? this.convertToDatetime(this.maximumDate)
                : this.maxDate()
        },
        minimumDate(): void {
            this.setMinDate = this.minimumDate
                ? this.convertToDatetime(this.minimumDate)
                : this.minDate()
        }
    }
})
